import { inject, injectable } from 'inversify';

import { User } from '@project44/ui-utils';
import { DtoBase, TenantModels } from '@project44-models/iam-gateway';

import { ParametersValueObject } from '../../../../shared/core/domain/ParameterValueObject';
import { TPublic } from '../../../../shared/core/domain/types';
import { ValueObject } from '../../../../shared/core/domain/ValueObject';
import { TenantService } from '../../application/Tenant.service';
import { TenantFactory } from '../factories/Tenant.factory';

@injectable()
export class TenantController {
  constructor(
    @inject(TenantService)
    private readonly tenantService: TenantService,

    @inject(TenantFactory)
    private readonly tenantFactory: TenantFactory,
  ) {}

  public async queryTenants(
    user: User,
    payload: {
      tenantQuery: TPublic<TenantModels.TenantQueryViewModel>;
    },
  ): Promise<ValueObject<DtoBase<TenantModels.TenantQueryResultsViewModel>>> {
    return this.tenantService.queryTenants(
      user,
      ParametersValueObject.create({
        tenantQueryDto: this.tenantFactory.createTenantQueryDto(
          payload.tenantQuery,
        ),
      }),
    );
  }

  public async getTenantByUuid(
    ...params: Parameters<TenantService['getTenantByUuid']>
  ): Promise<{ tenant: DtoBase<TenantModels.TenantViewModel> }> {
    return this.tenantService.getTenantByUuid(...params);
  }
}
